/* Dieselino blog "guides" — lightweight UI enhancers (dependency-free). */
(function () {
  'use strict';

  function initDropdowns(root) {
    var dropdowns = (root || document).querySelectorAll('[data-bg-dropdown]');
    dropdowns.forEach(function (dd) {
      if (dd.dataset.bgBound) return;
      dd.dataset.bgBound = 'true';
      var toggle = dd.querySelector('[data-bg-dropdown-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = dd.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initSearch(root) {
    var boxes = (root || document).querySelectorAll('[data-bg-search]');
    boxes.forEach(function (box) {
      if (box.dataset.bgBound) return;
      box.dataset.bgBound = 'true';
      var input = box.querySelector('[data-bg-search-input]');
      var results = box.querySelector('[data-bg-search-results]');
      if (!input || !results) return;

      var timer = null;
      var controller = null;

      function close() {
        results.hidden = true;
        results.innerHTML = '';
        box.classList.remove('is-open');
      }

      function render(articles, query) {
        results.innerHTML = '';
        if (!articles.length) {
          var empty = document.createElement('p');
          empty.className = 'sf__bg-search__empty';
          empty.textContent = box.dataset.noResultsText || 'No results';
          results.appendChild(empty);
        } else {
          articles.forEach(function (art) {
            var link = document.createElement('a');
            link.className = 'sf__bg-search__item';
            link.href = art.url.replace('/blogs/', '/blog/');
            if (art.image) {
              var img = document.createElement('img');
              img.src = art.image;
              img.alt = '';
              img.loading = 'lazy';
              img.width = 48;
              img.height = 48;
              link.appendChild(img);
            }
            var title = document.createElement('span');
            title.textContent = art.title;
            link.appendChild(title);
            results.appendChild(link);
          });
          var all = document.createElement('a');
          all.className = 'sf__bg-search__all';
          all.href = input.form.action + '?type=article&q=' + encodeURIComponent(query);
          all.textContent = input.form.querySelector('button[type="submit"]').getAttribute('aria-label') + ' “' + query + '”';
          results.appendChild(all);
        }
        results.hidden = false;
        box.classList.add('is-open');
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (controller) controller.abort();
        if (q.length < 2) {
          close();
          return;
        }
        timer = setTimeout(function () {
          controller = window.AbortController ? new AbortController() : null;
          var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=article&resources[limit]=6';
          fetch(url, controller ? { signal: controller.signal } : undefined)
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
              render(articles, q);
            })
            .catch(function (err) {
              if (err && err.name !== 'AbortError') close();
            });
        }, 300);
      });
    });
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-bg-dropdown].is-open').forEach(function (dd) {
      if (!dd.contains(e.target)) {
        dd.classList.remove('is-open');
        var t = dd.querySelector('[data-bg-dropdown-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
    document.querySelectorAll('[data-bg-search].is-open').forEach(function (box) {
      if (!box.contains(e.target)) {
        box.classList.remove('is-open');
        var res = box.querySelector('[data-bg-search-results]');
        if (res) { res.hidden = true; res.innerHTML = ''; }
      }
    });
    var tip = document.getElementById('sf-ag-cite-tip');
    if (tip && tip.classList.contains('is-open')) {
      var citeLink = e.target.closest && e.target.closest('a.sf__ag-cite');
      if (!citeLink && !tip.contains(e.target)) hideCiteTip();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-bg-dropdown].is-open').forEach(function (dd) {
        dd.classList.remove('is-open');
      });
      document.querySelectorAll('[data-bg-search].is-open').forEach(function (box) {
        box.classList.remove('is-open');
        var res = box.querySelector('[data-bg-search-results]');
        if (res) { res.hidden = true; res.innerHTML = ''; }
      });
      hideCiteTip();
    }
  });

  var citeTip = null;
  var citeActiveLink = null;
  var citeHideTimer = null;
  var touchNoHover = false;

  try {
    touchNoHover = window.matchMedia('(hover: none)').matches;
  } catch (err) {}

  function getCiteTip() {
    if (citeTip && document.body.contains(citeTip)) return citeTip;
    citeTip = document.getElementById('sf-ag-cite-tip');
    if (!citeTip) {
      citeTip = document.createElement('div');
      citeTip.id = 'sf-ag-cite-tip';
      citeTip.className = 'sf__ag-cite-tip';
      citeTip.setAttribute('role', 'tooltip');
      citeTip.hidden = true;
      document.body.appendChild(citeTip);
    }
    if (!citeTip.dataset.bgBound) {
      citeTip.dataset.bgBound = 'true';
      citeTip.addEventListener('mouseenter', function () {
        clearTimeout(citeHideTimer);
      });
      citeTip.addEventListener('mouseleave', function () {
        scheduleHideCiteTip();
      });
    }
    return citeTip;
  }

  function parseCiteNumber(text) {
    var m = String(text || '').trim().match(/^\[?(\d+)\]?$/);
    return m ? parseInt(m[1], 10) : null;
  }

  function positionCiteTip(link) {
    var tip = getCiteTip();
    var rect = link.getBoundingClientRect();
    var gap = 10;
    var width = tip.offsetWidth;
    var height = tip.offsetHeight;
    var left = rect.left + rect.width / 2 - width / 2;
    left = Math.max(12, Math.min(left, window.innerWidth - width - 12));
    var placeAbove = rect.top > height + gap + 16;
    var top = placeAbove ? rect.top - height - gap : rect.bottom + gap;
    var arrowLeft = rect.left + rect.width / 2 - left;
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    tip.style.setProperty('--cite-arrow-left', Math.round(arrowLeft) + 'px');
    tip.classList.toggle('sf__ag-cite-tip--above', placeAbove);
    tip.classList.toggle('sf__ag-cite-tip--below', !placeAbove);
  }

  function showCiteTip(link) {
    var n = parseInt(link.getAttribute('data-cite'), 10);
    var source = document.getElementById('sf-ag-source-' + n);
    if (!source) return;
    clearTimeout(citeHideTimer);
    var tip = getCiteTip();
    tip.innerHTML = '<span class="sf__ag-cite-tip__body">' + source.innerHTML + '</span>';
    tip.hidden = false;
    tip.classList.add('is-open');
    if (citeActiveLink && citeActiveLink !== link) {
      citeActiveLink.removeAttribute('aria-describedby');
      citeActiveLink.classList.remove('is-cite-open');
    }
    citeActiveLink = link;
    link.setAttribute('aria-describedby', tip.id);
    link.classList.add('is-cite-open');
    positionCiteTip(link);
  }

  function hideCiteTip() {
    clearTimeout(citeHideTimer);
    if (!citeActiveLink && !(citeTip && citeTip.classList.contains('is-open'))) return;
    var tip = getCiteTip();
    tip.hidden = true;
    tip.classList.remove('is-open');
    tip.innerHTML = '';
    if (citeActiveLink) {
      citeActiveLink.removeAttribute('aria-describedby');
      citeActiveLink.classList.remove('is-cite-open');
      citeActiveLink = null;
    }
  }

  function scheduleHideCiteTip() {
    clearTimeout(citeHideTimer);
    citeHideTimer = setTimeout(hideCiteTip, 160);
  }

  function initCiteTooltips(root) {
    var scope = root && root.querySelector
      ? (root.querySelector('.sf__article-guides') || root)
      : document;
    var sourcesList = document.querySelector('.sf__ag-sources__list');
    if (!sourcesList || !sourcesList.children.length) return;

    var contentRoots = scope.querySelectorAll(
      '.sf__ag-content, .sf__ag-callout__text, .sf__ag-faq__a'
    );
    contentRoots.forEach(function (area) {
      if (area.closest && area.closest('.sf__ag-sources')) return;
      Array.prototype.forEach.call(area.querySelectorAll('a[href]'), function (link) {
        if (link.dataset.bgCiteBound) return;
        if (link.closest('.sf__ag-sources')) return;
        var n = parseCiteNumber(link.textContent);
        if (!n) return;
        if (!document.getElementById('sf-ag-source-' + n)) return;

        link.dataset.bgCiteBound = 'true';
        link.classList.add('sf__ag-cite');
        link.setAttribute('data-cite', String(n));
        if (!link.getAttribute('target')) link.setAttribute('target', '_blank');
        if (!link.getAttribute('rel')) link.setAttribute('rel', 'noopener nofollow');

        link.addEventListener('mouseenter', function () {
          if (touchNoHover) return;
          showCiteTip(link);
        });
        link.addEventListener('mouseleave', function () {
          if (touchNoHover) return;
          scheduleHideCiteTip();
        });
        link.addEventListener('focus', function () {
          showCiteTip(link);
        });
        link.addEventListener('blur', function () {
          scheduleHideCiteTip();
        });
        link.addEventListener('click', function (e) {
          if (!touchNoHover) return;
          if (citeActiveLink !== link) {
            e.preventDefault();
            showCiteTip(link);
          }
        });
      });
    });

    if (!window.__sfAgCiteResizeBound) {
      window.__sfAgCiteResizeBound = true;
      window.addEventListener('scroll', function () {
        if (citeActiveLink) positionCiteTip(citeActiveLink);
      }, { passive: true });
      window.addEventListener('resize', function () {
        if (citeActiveLink) positionCiteTip(citeActiveLink);
      });
    }
  }

  function initToc(root) {
    var tocs = (root || document).querySelectorAll('[data-bg-toc]');
    tocs.forEach(function (toc) {
      if (toc.dataset.bgBound) return;
      toc.dataset.bgBound = 'true';
      var links = Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]'));
      var targets = links
        .map(function (link) { return document.getElementById(link.getAttribute('href').slice(1)); })
        .filter(Boolean);
      if (!targets.length) return;

      links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          var target = document.getElementById(link.getAttribute('href').slice(1));
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
        });
      });

      function setActive(id) {
        links.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
        });
      }

      if (!('IntersectionObserver' in window)) return;
      var visible = {};
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible[entry.target.id] = entry.isIntersecting;
        });
        for (var i = targets.length - 1; i >= 0; i--) {
          if (visible[targets[i].id]) {
            setActive(targets[i].id);
            return;
          }
        }
      }, { rootMargin: '-80px 0px -60% 0px' });
      targets.forEach(function (target) { observer.observe(target); });
    });
  }

  function initCopyLink(root) {
    var buttons = (root || document).querySelectorAll('[data-bg-copy]');
    buttons.forEach(function (btn) {
      if (btn.dataset.bgBound) return;
      btn.dataset.bgBound = 'true';
      btn.addEventListener('click', function () {
        var url = window.location.href.split('#')[0];
        function done() {
          btn.classList.add('is-copied');
          var label = btn.getAttribute('aria-label');
          if (btn.dataset.copiedText) btn.setAttribute('aria-label', btn.dataset.copiedText);
          setTimeout(function () {
            btn.classList.remove('is-copied');
            if (label) btn.setAttribute('aria-label', label);
          }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        } else {
          var input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          try { document.execCommand('copy'); done(); } catch (err) {}
          document.body.removeChild(input);
        }
      });
    });
  }

  /*
    AJAX tag filtering on the guides listing: tab / dropdown / pagination links
    are fetched via the Section Rendering API and swapped in place, so the
    /tagged/ URLs keep working (SEO, no-JS fallback) without a full reload.
    The browser URL is intentionally left untouched.
  */
  var AJAX_REGIONS = ['hero', 'filters', 'count', 'main'];

  function initAjaxFilters(root) {
    var sections = (root || document).querySelectorAll('[data-section-type="blog-guides"]');
    sections.forEach(function (section) {
      if (section.dataset.bgAjaxBound) return;
      section.dataset.bgAjaxBound = 'true';
      var sectionId = section.getAttribute('data-section-id');
      if (!sectionId || !window.fetch || !window.DOMParser) return;

      var controller = null;

      function region(scope, name) {
        return scope.querySelector('[data-bg-ajax-region="' + name + '"]');
      }

      function load(url) {
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var fetchUrl;
        try {
          fetchUrl = new URL(url, window.location.origin);
        } catch (err) {
          window.location.href = url;
          return;
        }
        fetchUrl.searchParams.set('section_id', sectionId);
        section.classList.add('is-loading');
        section.setAttribute('aria-busy', 'true');
        fetch(fetchUrl.toString(), controller ? { signal: controller.signal } : undefined)
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var complete = AJAX_REGIONS.every(function (name) {
              return region(doc, name) && region(section, name);
            });
            if (!complete) throw new Error('Missing ajax regions in section response');
            AJAX_REGIONS.forEach(function (name) {
              region(section, name).replaceWith(region(doc, name));
            });
            section.classList.remove('is-loading');
            section.removeAttribute('aria-busy');
            initAll(section);
            var filters = region(section, 'filters');
            if (filters && filters.getBoundingClientRect().top < 0) {
              filters.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            window.location.href = url;
          });
      }

      section.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (!e.target.closest) return;
        var link = e.target.closest(
          '[data-bg-ajax-region="filters"] a[href], [data-bg-ajax-region="main"] .sf__bg-pagination a[href]'
        );
        if (!link || link.target === '_blank') return;
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) === '#') return;
        e.preventDefault();
        load(link.href);
      });
    });
  }

  // Safety net for anchors the server-side snippets (external-nofollow, link-attrs) can't see,
  // e.g. links injected by apps or written as "<a\n href".
  function initExternalNofollow(root) {
    var scope = root && root.querySelector
      ? (root.querySelector('.sf__article-guides') || root)
      : document;
    var areas = scope.querySelectorAll(
      '.sf__ag-content, .sf__ag-callout__text, .sf__ag-cta, .sf__ag-faq__a, ' +
      '.sf__ag-table-wrap, .sf__ag-takeaways, .sf__ag-sources, .sf__ag-pbanner, ' +
      '.sf__ag-picks, .sf__ag-bio'
    );
    areas.forEach(function (area) {
      Array.prototype.forEach.call(area.querySelectorAll('a[href]'), function (link) {
        var href = link.getAttribute('href') || '';
        var host;
        if (!href || href.charAt(0) === '#') return;
        try { host = new URL(href, location.href); } catch (err) { return; }
        if (!/^https?:$/.test(host.protocol)) return;
        if (!link.getAttribute('target')) link.setAttribute('target', '_blank');
        if (host.hostname === location.hostname) return;
        var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
        if (rel.indexOf('nofollow') === -1) {
          rel.push('nofollow');
          link.setAttribute('rel', rel.join(' '));
        }
      });
    });
  }

  function initAll(root) {
    initExternalNofollow(root);
    initDropdowns(root);
    initSearch(root);
    initToc(root);
    initCopyLink(root);
    initCiteTooltips(root);
    initAjaxFilters(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init inside the Shopify theme editor when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
